export const UserStatusList = ["active", "inactive", "suspended"] as const;
export const UserThingTypeMrn = "mrn::::user";
// "clerk" retained for historical user records; new users are created with
// "auth0" (LOCKER-319 removed the Clerk auth layer).
export const IdPNames = ["clerk", "auth0"] as const;
